import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import config from "../config";

const { api } = config;

// default
axios.defaults.baseURL = process.env.REACT_APP_API_URL || api.API_URL;

// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// auth token
const authUser: any = sessionStorage.getItem("authUser");
const token = JSON.parse(authUser) ? JSON.parse(authUser).token : null;
console.log("API_HELPER_ ++++++  token", token)
console.log("API_HELPER_  authUser", authUser)
if (token) {
  console.log("Loaded token from sessionStorage:", token);
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    const data = response.data;
    // console.log("Response received:", response);
    
    // Check for Unauthorized code "2" (could be string or number, Code or code)
    if (data && (data.Code == "2" || data.code == "2")) {
      console.error("Unauthorized access detected (Code 2). Clearing session and redirecting to login.");
      sessionStorage.removeItem("authUser");
      localStorage.removeItem("authUser");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
      return Promise.reject(data.Message || data.message || "Unauthorized");
    }
    return response.data ? response.data : response;
  },
  function (error) {
    console.log("Error received:", error);
    let message;
    if (error.response && (error.response.status === 401 || (error.response.data && (error.response.data.Code == "2" || error.response.data.code == "2")))) {
      sessionStorage.removeItem("authUser");
      localStorage.removeItem("authUser");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
      message = "Session expired. Please login again.";
    } else {
      switch (error.response ? error.response.status : error.status) {
        case 500:
          message = "Internal Server Error";
          break;
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the data you are looking for could not be found";
          break;
        default:
          message = error.message || error;
      }
    }
    return Promise.reject(message);
  }
);

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token: string | null) => {
  console.group("Setting authorization");
  console.log("New token:", token);
  
  if (token) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    console.log("Authorization header set with token:", token);
  } else {
    delete axios.defaults.headers.common["Authorization"];
    console.log("Authorization header cleared");
  }

  console.groupEnd();
};

class APIClient {
  /**
   * Fetches data from given url
   */
  get = (url: string, params: any) => {
    console.group("GET Request");
    console.log("URL:", url);
    console.log("Params:", params);

    let response;
    let paramKeys: string[] = [];

    if (params) {
      Object.keys(params).map(key => {
        paramKeys.push(key + "=" + params[key]);
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join("&") : "";
      console.log("Query string:", queryString);
      response = axios.get(`${url}?${queryString}`);
    } else {
      response = axios.get(url);
    }

    console.groupEnd();
    return response;
  };

  /**
   * post given data to url
   */
  create = (url: string, data: any) => {
    console.group("POST Request");
    console.log("URL:", url);
    console.log("Data:", data);
    console.groupEnd();
    return axios.post(url, data);
  };

  /**
   * Updates data
   */
  update = (url: string, data: any) => {
    console.group("PATCH Request");
    console.log("URL:", url);
    console.log("Data:", data);
    console.groupEnd();
    return axios.patch(url, data);
  };

  put = (url: string, data: any) => {
    console.group("PUT Request");
    console.log("URL:", url);
    console.log("Data:", data);
    console.groupEnd();
    return axios.put(url, data);
  };

  /**
   * Delete
   */
  delete = (url: string, config?: AxiosRequestConfig): Promise<AxiosResponse> => {
    console.group("DELETE Request");
    console.log("URL:", url);
    console.log("Config:", config);
    console.groupEnd();
    return axios.delete(url, { ...config });
  };
}

const getLoggedinUser = () => {
  const user = sessionStorage.getItem("authUser") || localStorage.getItem("authUser");
  console.log("Logged in user (from session or local):", user);
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedinUser };
